import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StockLocation } from '../../model/location/stock-location';
import { LoadingService } from '../loading.service';
import { SnackService } from '../snack.service';
import { ProperPageResult } from '../../model/proper-page-result';
import { Observable } from 'rxjs';
import { SignPlacementPrice } from '../../model/sign/sign-placement-price/sign-placement-price';
import { _get, _post, _put } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class LocationsControllerRequestService {
  private static BASE_URL = '/locations';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly put: <T>(
    path: string,
    body: SignPlacementPrice,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: SignPlacementPrice,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializePaged = (res) => {
    const result: ProperPageResult<StockLocation> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };
  private readonly deserialize = (res) => res as StockLocation;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      LocationsControllerRequestService.BASE_URL,
      requestServices
    );
    this.post = _post(
      LocationsControllerRequestService.BASE_URL,
      requestServices
    );
    this.put = _put(
      LocationsControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public create(location: StockLocation): Promise<StockLocation> {
    return this.post('', location, this.deserialize).toPromise();
  }

  public update(location: StockLocation): Promise<StockLocation> {
    return this.put('', location, this.deserialize).toPromise();
  }

  public getPage(
    filters: string,
    sort: string,
    sortAscending: boolean,
    pageSize: number,
    page: number,
    showArchived: boolean
  ): Promise<ProperPageResult<StockLocation>> {
    const filtersParam: string = `filters=${filters}`;
    const pageableParam: string = `page=${page}&size=${pageSize}&sortDirection=${
      sortAscending ? 'ASC' : 'DESC'
    }&sortProperty=${sort}`;
    const showArchivedParam: string = `showArchived=${showArchived}`;
    //This is gonna be common, should extract/generalize this later
    const pathParams: string = `?${filtersParam}&${pageableParam}&${showArchivedParam}`;

    return this.get(pathParams, this.deserializePaged).toPromise();
  }
}
